import React, { useState } from "react";
import uploadImage from "../../assets/images/icons/upload.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { getDownloadURL, ref, uploadBytesResumable, deleteObject } from "firebase/storage";
import { doc, updateDoc } from "firebase/firestore";


const ImageUploader = ({ setFile ,title}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile({
        file: file,
        name: file.name,
        type: file.type,
        preview: URL.createObjectURL(file),
        downloadURL: null,
      });
      setFile({
        file: file,
        name: file.name,
        type: file.type,
        preview: URL.createObjectURL(file),
        downloadURL: null,
      });
      
    }
  };

  const handleDelete = async () => {
    if (selectedFile ) {
      setSelectedFile(null);
      setFile(null);
    }
  };



  return (
    <div className="image-uploader">
      <div className="file-upload-info file-up">
        <div className="image-upload">
          <img src={uploadImage} alt="upload icon" loading="lazy" />
        </div>
        <div className="info-content">
          <h2 className="title">{title}</h2>
        </div>
        <input type="file" accept="image/*" onChange={handleFileChange} />
      </div>
      {selectedFile && (
       <div className="d-flex justify-content-center mt-4">

<div className="main-upload-info">
          <img
            src={selectedFile.preview}
            alt={selectedFile.name}
            style={{ width: "100px", height: "auto" }}
          />
          <div
            className="button-remove-up d-flex justify-content-center align-items-center"
            onClick={handleDelete}
          >
            <FontAwesomeIcon icon={faTrash} />
          </div>
       
        </div>
       </div>
      )}
    </div>
  );
};

export default ImageUploader;
